import { css } from 'styled-components';
import { resetBox } from './resetBox';

export const resetInput = css`
  ${resetBox}

  appearance: none;
  border: 0;
  padding: 0;
  background: transparent;
  border-radius: 0;
  outline: none;
  resize: none;
`;
